<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.74753 5.9325C1.41489 5.73992 1.41489 5.25966 1.74753 5.06707L10.2351 0.153224C10.3977 0.0590611 10.5994 0.0640556 10.7572 0.166153L18.3514 5.08C18.6559 5.27703 18.6559 5.72254 18.3514 5.91957L10.7572 10.8334C10.5994 10.9355 10.3977 10.9405 10.2351 10.8463L1.74753 5.9325Z"
      fill="white"
    />
    <path
      d="M11.5 12.7678C11.5 12.6006 11.5836 12.4445 11.7226 12.3517L18.2227 8.01841C18.5549 7.79689 19 8.03509 19 8.43443V15.0968C19 15.2561 18.9241 15.4058 18.7957 15.5L12.2957 19.4167C11.9654 19.6589 11.5 19.423 11.5 19.0135V12.7678Z"
      fill="white"
    />
    <path
      d="M1 14.7139C1 14.8911 1.09377 15.0551 1.24649 15.1449L8.74649 19.5567C9.07981 19.7527 9.5 19.5124 9.5 19.1257V12.7859C9.5 12.6087 9.40623 12.4448 9.25351 12.3549L1.75351 7.94316C1.42019 7.74709 1 7.98741 1 8.37412V14.7139Z"
      fill="white"
    />
  </svg>
</template>
